<template>
  <div>
    <div class="vx-row">
      <vx-card title no-shadow card-border>
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="flex items-end px-3">
              <span class="font-medium text-lg leading-none">{{
                $t("inventory.label.EditFeeMaster")
              }}</span>
            </div>
            <vs-divider />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <vs-input
              :label="$t('inventory.label.Type')"
              class="w-full mb-2 font-semibold"
              v-model="this.type"
              disabled
            />
            <vs-input
              :label="$t('inventory.label.SalesId')"
              class="w-full mb-2 font-semibold"
              v-model="this.salesId"
              disabled
            />
            <vs-input
              :label="$t('inventory.label.SerialNo')"
              class="w-full mb-2 font-semibold"
              v-model="sales.serialNumber"
            />
          </div>
        </div>
        <div class="vx-row float-right my-2">
          <div class="vx-col w-full">
            <vs-button class="mr-3 mb-2" @click="createFee">{{
              $t("inventory.label.Submit")
            }}</vs-button>
            <vs-button
              color="warning"
              type="border"
              class="mb-2"
              @click="resetForm"
              >{{ $t("inventory.label.Cancel") }}
            </vs-button>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
import { concat, filter } from "lodash";
import moment from "moment";
import { getBySalesId } from "@/http/inventory";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";

const feeEmptyObj = {
  id: "",
  itemDescription: "",
  serialNumber: "",
};

export default {
  data() {
    return {
      amount: "",
      salesId: "",
      type: "sale",
      fee: feeEmptyObj,
      id: "",
      itemDescription: "",
      serialNumber: "",
      sales: "",
    };
  },
  components: {
    Datepicker,
    "v-select": vSelect,
  },
  computed: {},
  mounted() {},
  methods: {
    async getBySalesId() {
      try {
        const response = await getBySalesId(this.id);
        this.sales = response.data;
        this.salesId = this.sales.id + "--" + this.sales.itemDescription;
        //   this.good.id = response.data.
        //   this.good.purchaseDate=this.getDate(this.good.requestedDate);
        //   this.fee.transactionType = response.data.feeMasterData.transactionType;
        //   this.fee.chargeCode = response.data.feeMasterData.chargeCode;
        //   this.fee.feeDescription = response.data.feeMasterData.feeDescription;
      } catch (error) {
        console.log(
          "something went to wrong while retrieving job by id:",
          error
        );
      }
    },

    async createFee() {
      this.fee = {
        removeRegionPrices: "",
        feeCode: this.fee.feeCode,
        feeDescription: this.fee.feeDescription,
        transactionType: this.fee.transactionType,
        chargeCode: this.fee.chargeCode,

        isRefundable: "N",
        locale: "en",
        defaultFeeAmount: "0",
      };
      this.fee.removeRegionPrices = [];
      this.fee.regionPrices = this.regionPrices;

      try {
        const resp = await updateFee(this.id, this.fee);
        if (resp.data.resourceId) {
          this.$router.push("/fee_master");
          this.resetForm();
        }
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
        console.log("something went to wrong while creating Fee:", e);
      }
    },
    resetForm() {
      this.fee = feeEmptyObj;
      (this.fee.feeCode = ""), (this.fee.feeDescription = "");
      this.fee.transactionType = "";
      this.fee.chargeCode = "";
    },
  },
  created() {
    this.id = this.$route.params.id;
    //   this.viewMRNStockTransfer();
    this.getBySalesId();
  },
  watch: {
    fees(value) {
      this.fee.regionDatas = value.feeMasterRegionPricesDatas;
    },
    regionPrices2(value) {
      for (let tempPrice of value) {
        let tempObj = { id: "", amount: "", locale: "en" };
        tempObj.id = tempPrice.regionId;
        tempObj.amount = tempPrice.amount;
        this.regionPrices.push(tempObj);
      }
    },
  },
};
</script>
